module.exports = __webpack_public_path__ + "img/douyin.1725eeb3.png";